<div class="d-flex justify-content-center h-100 mt-5">
    <div class="row mb-5">
        <div class="col-sm-5 border-right mb-5">
            <div class="d-flex w-100 h-100 align-items-center">
                <div class="container w-75 h-75 pr-3 text-center">
                    <img class="img-fluid" id="logo" src="../../../assets/smiley_logo.svg">
                    <h1 class="dsc pt-3">Sign up and chat with people sharing similar problems!</h1>
                </div>
            </div>
        </div>
        <div class="col-sm-7">
            <div class="w-75 mx-auto">
                <form [formGroup]="form" class="text-center border border-primary p-4 z-depth-2" (ngSubmit)="doLogin()">
                    <div class="d-flex justify-content-center">
                        <h1 class="mb-4">Log In</h1>
                    </div>
                    <div class="mb-4">
                        <mdb-icon fas icon="user"></mdb-icon>
                        <input mdbInput type="email" formControlName="emailFormEx" minLength="5" class="form-control" placeholder="E-mail">
                        <span *ngIf="emailFormEx && !emailFormEx.valid && emailFormEx.dirty && emailFormEx.touched" class="text-danger">Incorrect email format</span>
                    </div>
                    <mdb-icon fas icon="key"></mdb-icon>
                    <input mdbInput type="password" formControlName="password" id="defaultLoginFormPassword" class="form-control mb-4" placeholder="Password">

                    <div class="d-flex justify-content-around ">
                        <div>
                            <!-- <a href="">Forgot password?</a> -->
                        </div>
                    </div>
                    <p class="mt-3">
                        <a href="/register">Register</a>
                    </p>
                    <gb-action-button [isLoading]="loadingLogin" [whenDisabled]="!form.valid" [text]="'Sign In'" [iconClass]="'sign-in-alt'"></gb-action-button>

                </form>
            </div>
        </div>
    </div>
</div>

<div class="overlay" *ngIf="routeToMobile">
    <div class="col-sm-3 p-2 popup-container">
        <loading-spinner></loading-spinner>
        <div class="card card-1 border border-primary p-1 z-depth-1">
            <div class="card-body text-center">
                <h5 class="card-title"><b>Would you like to use our mobile app?</b></h5>
                <img class="p-2" src="../../../assets/gbicon_mobile.png">
                <div class="p-3">
                    <button mdbBtn mdbWavesEffect (click)="routeToMobileApp()" color="blue" class="btn btn-sm">Go to app</button>
                </div>
                <a class="text-muted" (click)="routeToMobile = false">Continue in browser</a>
            </div>
        </div>
    </div>
</div>